import theme from '@theme';
import React, { Fragment } from 'react';
import styled from 'styled-components';

import { DisplayFieldName, DisplayFieldValue, SubTitle } from '../display-form';
import { Section } from './types';

const DisplaySection: React.FC<Section> = ({
  title,
  custom,
  fields,
  isVisible,
  color
}: Section) => {
  if (!isVisible) return null;

  if (custom) return custom;

  return (
    <BodyContainer>
      <SubTitle color={color ?? 'blue'} display={title ?? ''} />
      <GridContainer>
        {fields?.map(({ title: fieldTitle, icon: fieldIcon, value: fieldValue }) => (
          <Fragment key={title}>
            <DisplayFieldName iconName={fieldIcon}>{fieldTitle}</DisplayFieldName>
            <DisplayFieldValue label={fieldValue.label} badge={fieldValue.badge} />
          </Fragment>
        ))}
      </GridContainer>
    </BodyContainer>
  );
};

const BodyContainer = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: start;
  align-items: start;
  padding: 0.5rem 0;
  border-bottom: 1px solid ${theme.palette.grey[100]};
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 10rem 1fr;
  column-gap: 0.75rem;
  row-gap: 0.625rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  justify-items: start;
`;

export default DisplaySection;
